import React from "react";

import { siteLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import { TestButtonLink } from "./TestButtonLink";
import { TestInput } from "./TestInput";

export const TestGeneralActions = () => (
  <div>
    <TestButton url={`${siteLocationPrefix}/test/resetUser`} title="Reset User" />
    <TestButtonLink
      title="Client form responses"
      url={`${siteLocationPrefix}/test/console/clientforms`}
      type={Programs.IdXbox}
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setUserOverride`}
      label="User email override ('delete' to remove) "
      buttonText="change"
      actionName="emailOverride"
    />
    <TestButton url={`${siteLocationPrefix}/test/nukePartner/preview`} title="Preview nuke me" />
    <TestButton url={`${siteLocationPrefix}/test/nukePartner/confirm`} title="Nuke me" />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/nukePartner/preview`}
      label="Preview nuke account by email "
      buttonText="preview"
      actionName="email"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/nukePartner/confirm`}
      label="Nuke account by email (deletes hub profile + onboarding, deactivates contacts + solo account) "
      buttonText="nuke"
      actionName="email"
    />
    <br />
    <br />
  </div>
);
